module.exports = require("@swa-ui/itinerary/src/AutocompleteVacationDestinations/AutocompleteVacationDestinations.module.scss");